import { useContext } from 'react';
import { favoriteProductsContext } from './favorite-product-context';

export function useFavoriteProductIdContext() {
  const favoriteProducts = useContext(favoriteProductsContext);
  if (!favoriteProducts) {
    throw new Error(
      'favoriteProductsContext value is undefined. Make sure you use the FavoriteProductsProvider before using the context.'
    );
  }
  return favoriteProducts;
}
